'use client'
import React from 'react'
import { Button, Grid, Link, Toolbar, Typography } from '@mui/material'
import { AccountCircle } from '@mui/icons-material'
import { signOut, useSession } from 'next-auth/react'

export const Header = () => {
  const { data: session } = useSession()

  return (
    <Toolbar variant='dense'>
      <Grid container spacing={4} alignItems='center'>
        <Grid item xs='auto'>
          <Typography fontSize='24px' lineHeight='32px'>
            <Link href='/' underline='none' color='inherit'>
              FaveU Dashboard
            </Link>
          </Typography>
        </Grid>
        <Grid item sx={{ flexGrow: 1 }} />
        <Grid item xs='auto'>
          <AccountCircle sx={{ mr: 1 }} />
          {session?.user.name}
        </Grid>
        <Grid item xs='auto'>
          <Button
            variant='contained'
            disableElevation
            sx={{
              py: 0,
              fontSize: '14px',
              fontWeight: 700,
              lineHeight: '36px',
              backgroundColor: '#F5F5F5',
              color: '#000000DE',
              '&:hover': { backgroundColor: '#F5F5F5' }
            }}
            onClick={() => signOut()}
          >
            サインアウト
          </Button>
        </Grid>
      </Grid>
    </Toolbar>
  )
}
